export default function productSearchCtrl($scope) {
    window.onkeydown = function (e) {
        if (e.keyCode == 70 && e.ctrlKey) {
            e.preventDefault();
            angular.element('button[data-target="#drawer-search"]').get(0).click();
            angular.element('#form-search').find('input').focus();
        }
    }

    $scope.$watch('selectedProduct', function (oldval, newval) {
        try {
            window.location.href = $scope.selectedProduct.originalObject.href;
        } catch (e) {

        }
    });
}

productSearchCtrl.$inject = ['$scope'];

// export default class productSearchCtrl {
//     constructor($scope, $http, $rootScope, $compile) {
//         'ngInject'

//         window.onkeydown = function (e) {
//             if (e.keyCode == 70 && e.ctrlKey) {
//                 e.preventDefault();
//                 angular.element('button[data-target="#drawer-search"]').get(0).click();
//                 angular.element('#form-search').find('input').focus();
//             }
//         }

//         $scope.$watch('selectedProduct', function (oldval, newval) {
//             try {
//                 window.location.href = $scope.selectedProduct.originalObject.href;
//             } catch (e) {

//             }
//         });
//     }
// }